import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance, { serverURL } from "../../services/FetchNodeServices";

const EditCatalog = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        file: null,
    });
    const [existingFile, setExistingFile] = useState("");

    const params = useParams();
    const navigate = useNavigate();

    /** -------------------------
     * Fetch catalogue by ID
     * ------------------------*/
    const fetchCatalogue = async () => {
        try {
            const res = await axiosInstance.get(`/api/v1/catalogues/get-catalogue/${params.id}`);

            if (res.status === 200) {
                setFormData({ name: res.data.data.name, file: null });
                setExistingFile(res.data.data.file);
            }
        } catch (error) {
            toast.error("Error loading catalogue");
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCatalogue();
    }, []);

    /** -------------------------
     * Handle Input Change
     * ------------------------*/
    const handleChange = (e) => {
        const { name, type, files, value } = e.target;
        if (type === "file") {
            setFormData((prev) => ({ ...prev, file: files[0] }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    /** -------------------------
     * Submit Update Request
     * ------------------------*/
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const payload = new FormData();
        payload.append("name", formData.name);
        if (formData.file) payload.append("file", formData.file);

        try {
            const res = await axiosInstance.post(
                `/api/v1/catalogues/update/${params.id}`,
                payload,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (res.status === 200) {
                toast.success("Catalogue updated successfully");
                navigate("/all-catalogue");
            } else {
                toast.error("Error updating catalogue");
            }
        } catch (error) {
            toast.error("Error updating catalogue");
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="bread">
                <div className="head">
                    <h4>Edit Catalogue</h4>
                </div>
                <div className="links">
                    <Link to="/all-catalogue" className="add-new">
                        Back <i className="fa-regular fa-circle-left"></i>
                    </Link>
                </div>
            </div>

            <div className="d-form">
                <form className="row g-3" onSubmit={handleSubmit}>
                    <div className="col-md-4">
                        <label className="form-label">Catalogue Name</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Upload New PDF (Optional)</label>
                        <input
                            type="file"
                            name="file"
                            className="form-control"
                            accept="application/pdf"
                            onChange={handleChange}
                        />
                    </div>

                    {existingFile && (
                        <div className="col-md-12">
                            <p>Existing File:</p>
                            <a
                                href={`${serverURL}/${existingFile}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "blue", textDecoration: "underline" }}
                            >
                                View / Download Current PDF
                            </a>
                        </div>
                    )}

                    <div className="col-md-12 mt-3">
                        <button type="submit" className="bt" disabled={isLoading}>
                            {isLoading ? "Updating..." : "Update Catalogue"}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default EditCatalog;
